import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "14",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "var(--_dn-icon_color)",
      "fill-rule": "evenodd",
      d: "M19.06 2.02 7.6 13.04.94 6.637l1.04-1.081L7.6 10.96 18.02.94z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }